import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=db6adcda&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=db6adcda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6adcda",
  null
  
)

export default component.exports